module.exports = __webpack_public_path__ + "img/turanza_6.7be44bf2.png";